import React, { useState, useRef, useEffect, useMemo } from 'react';
import { ChevronUp, ChevronDown, Maximize, ArrowLeft } from 'lucide-react';

import ShortVideoPlayer from './ShortVideoPlayer';


const extractYouTubeId = (urlOrId?: string): string => {
  if (!urlOrId) return '';
  const trimmed = String(urlOrId).trim();
  if (trimmed.length === 11 && !trimmed.includes('/') && !trimmed.includes('.')) return trimmed;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = trimmed.match(regExp);
  return (match && match[2].length === 11) ? match[2] : '';
};

export default function ShortsFeed({ videos, onBack, initialVideoId, onLoadMore }: { videos: any[], onBack?: () => void, initialVideoId?: string, onLoadMore?: () => void }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(false);
  
  // 🚀 NOVO: Limite de vídeos renderizados na tela (Começa com 15 para ficar muito leve)
  const [displayLimit, setDisplayLimit] = useState(15);

  const containerRef = useRef<HTMLDivElement>(null);
  const mainContainerRef = useRef<HTMLDivElement>(null);
  const hasAutoScrolled = useRef(false);

  const toggleFullScreen = () => {
    if (!mainContainerRef.current) return;
    if (!document.fullscreenElement) {
      mainContainerRef.current.requestFullscreen().catch(err => console.log(err));
    } else {
      document.exitFullscreen();
    }
  };

  // 🎲 1. TODOS OS SHORTS (Apenas em texto/memória - Não pesa nada)
  // 🎲 1. TODOS OS SHORTS (Apenas em texto/memória - Não pesa nada)
  const allShorts = useMemo(() => {
    return videos.filter((v: any) => 
      v.post_type === 'shorts' || v.is_short === true || (v.category || '').toLowerCase().includes('shorts')
    );
  }, [videos]); // 👈 Removemos o sort(Math.random()) daqui!

  // 🛡️ 2. SHORTS NA TELA (Só desenha o que está dentro do limite)
  // 🛡️ 2. SHORTS NA TELA (Loop Infinito Mágico)
 // 🛡️ 2. SHORTS NA TELA (Agora é a lista real, sem repetições falsas!)
  const shortsVideos = useMemo(() => {
    if (allShorts.length === 0) return [];
    
    // Mostra apenas até o limite atual (para não pesar o celular renderizando tudo de uma vez)
    return allShorts.slice(0, displayLimit).map((v, i) => ({
      ...v,
      loop_id: i
    }));
  }, [allShorts, displayLimit]);

  // 🎯 SCROLL INTELIGENTE PARA LINK ESPECÍFICO
 // 🎯 SCROLL INTELIGENTE PARA LINK ESPECÍFICO (Galeria, URL ou Notificação)
  useEffect(() => {
    if (!hasAutoScrolled.current && allShorts.length > 0) {
      // 👈 Prioriza o initialVideoId passado por parâmetro ou pega da URL
      const targetVideoId = initialVideoId || new URLSearchParams(window.location.search).get('v');
      
      if (targetVideoId) {
        const targetIndex = allShorts.findIndex((v: any) => v.id === targetVideoId);
        
        if (targetIndex !== -1) {
          // Se o vídeo estiver lá pro final, aumenta o limite do displayLimit na hora para ele existir na lista!
          if (targetIndex >= displayLimit) {
            setDisplayLimit(targetIndex + 5);
            return; // Aguarda o próximo ciclo para renderizar com o novo limite
          }
          
          setActiveIndex(targetIndex); 
          
          setTimeout(() => {
            if (containerRef.current) {
              const height = containerRef.current.clientHeight;
              containerRef.current.scrollTop = targetIndex * height;
              hasAutoScrolled.current = true; 
            }
          }, 50);
        } else {
          hasAutoScrolled.current = true;
        }
      } else {
        hasAutoScrolled.current = true;
      }
    }
  }, [allShorts, displayLimit, initialVideoId]);

  // ⏱️ CRONÔMETRO DO AUTO-PLAY
  useEffect(() => {
    let timer: NodeJS.Timeout;
    
    if (isAutoPlay) {
      timer = setTimeout(() => {
        if (activeIndex < allShorts.length - 1) {
          const nextIndex = activeIndex + 1;
          
          // Se o Auto-Play estiver chegando perto do limite atual, libera mais 15 vídeos
          if (nextIndex >= displayLimit - 2) {
            setDisplayLimit(prev => prev + 15);
          }

          if (containerRef.current) {
            const height = containerRef.current.clientHeight;
            containerRef.current.scrollTo({
              top: nextIndex * height,
              behavior: 'smooth'
            });
            setActiveIndex(nextIndex);
          }
        } else {
          setIsAutoPlay(false); 
        }
      }, 60000); 
    }
    
    return () => clearTimeout(timer);
  }, [isAutoPlay, activeIndex, allShorts.length, displayLimit]);

  // ↕️ CONTROLE DAS SETAS DO PC
 // ↕️ CONTROLE DAS SETAS DO PC
  const scrollToVideo = (index: number) => {
    if (index >= displayLimit - 3) {
      setDisplayLimit(prev => prev + 15); // Libera espaço na tela
    }

    // 👇 O SEGREDO DO PC: Avisa o pai para buscar mais no Supabase!
    if (onLoadMore && index >= allShorts.length - 5) {
      onLoadMore();
    }

    if (containerRef.current) {
      const height = containerRef.current.clientHeight;
      containerRef.current.scrollTo({
        top: index * height,
        behavior: 'smooth'
      });
      setActiveIndex(index);
    }
  };

  // 📜 GATILHO INFINITO AO DESCER A TELA
  // 📜 GATILHO INFINITO AO DESCER A TELA
 // 📜 GATILHO INFINITO AO DESCER A TELA
  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const scrollTop = e.currentTarget.scrollTop;
    const height = e.currentTarget.clientHeight;
    const index = Math.round(scrollTop / height);
    
    if (index !== activeIndex) {
      setActiveIndex(index);
    }

    if (index >= displayLimit - 3) {
      setDisplayLimit(prev => prev + 15); // Libera mais cards vazios na tela
    }

    // 👇 O SEGREDO DO TELEMÓVEL: Pede o próximo lote de 20 ao Supabase
    if (onLoadMore && index >= allShorts.length - 5) {
      onLoadMore();
    }
  };

// ... restante do seu código exatamente como estava

 

  

  return (
    <div 
    ref={mainContainerRef}
    style={{ 
      position: 'relative', 
      width: '100vw', 
      height: 'calc(100vh - 70px)', 
      backgroundColor: '#000', 
      marginTop: '12px',
      display: 'flex', 
      alignItems: 'flex-start',    
      justifyContent: 'center', 
      overflow: 'hidden',
      paddingTop: '0px'
    }}>
      
      {/* 👇 BLOCO ADICIONADO: BOTÃO DE VOLTAR 👇 */}
      {onBack && (
        <button
          onClick={onBack}
          style={{
            position: 'absolute',
            top: '510px',
            left: '15px',
            zIndex: 200,
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            backgroundColor: 'rgba(0,0,0,0.6)',
            color: '#807a7a',
            border: '1px solid rgba(255,255,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            backdropFilter: 'blur(4px)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.38)'
          }}
          title="Voltar para Galeria"
        >
          <ArrowLeft size={20} />
        </button>
      )}
      {/* 👆 FIM DO BLOCO 👆 */}

     
      
      {/* CONTAINER DO FEED VERTICAL */}
      <div 
        ref={containerRef}
        onScroll={handleScroll}
        className="shorts-scroll-container"
        style={{ 
          height: '82vh',           // 👈 Controla a altura exata do player no PC (deixa compacto igual YouTube)
          maxHeight: '680px',       // 👈 Trava uma altura máxima para não esticar demais em telas grandes
          width: '100%',
          maxWidth: '380px',        // 👈 Largura padrão perfeita de celular/short
          overflowY: 'scroll', 
          scrollSnapType: 'y mandatory', 
          backgroundColor: '#000',
          scrollbarWidth: 'none', 
          msOverflowStyle: 'none',
          borderRadius: '16px',     // 👈 Deixa as bordas arredondadas igualzinho ao player do YouTube no PC
          border: '1px solid #222'  // 👈 Uma bordinha sutil para destacar o card
        }}
      >
        <style>{`
          div::-webkit-scrollbar { display: none; }
          /* No celular: ocupa 100% da largura e altura da tela, colando no menu */
          @media (max-width: 768px) {
            .shorts-scroll-container {
              max-width: 100% !important;
              max-height: calc(100vh - 70px) !important;
              border-radius: 0 !important;
            }
            .desktop-arrows-container { 
              display: none !important; 
            }
          }
        `}</style>

        {shortsVideos.map((video, index) => {
          const videoUrl = video.embed_id || video.full_video_id || video.trailer_url || video.url;
          const ytId = extractYouTubeId(videoUrl);
          const isActive = index === activeIndex;

          return (
            <div key={video.id || index} style={{ 
              height: '100%', 
              width: '100%', 
              
              // 👇 A MÁGICA DO KWAI ACONTECE AQUI 👇
              scrollSnapAlign: 'start',      // Alinha perfeitamente no topo
              scrollSnapStop: 'always',      // OBRIGA a parar de 1 em 1 (não pula vídeos)
              flex: '0 0 100%',              // Garante que o item ocupe exatamente 100% do espaço, impedindo saltos estranhos
              // 👆 FIM DA MÁGICA 👆

              position: 'relative', 
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#000'
            }}>
              
              <div style={{ 
                width: '100%', 
                height: '100%', 
                position: 'relative', 
                backgroundColor: '#111',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
              }}>
                
                {isActive && ytId ? (
                  <ShortVideoPlayer 
                    videoId={ytId} 
                    title={video.title} 
                    isActive={isActive} 
                    thumbnail={video.thumbnail || `https://img.youtube.com/vi/${ytId}/hqdefault.jpg`} // 👈 ADICIONAMOS ESSA LINHA
                    category={video.category} // 👈 SÓ ADICIONAR ESTA LINHA AQUI
                  />
                ) : (
                  <img 
                    src={video.thumbnail || `https://img.youtube.com/vi/${ytId}/hqdefault.jpg`} 
                    alt="Capa" 
                    loading="lazy" 
                    decoding="async" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.8)' }} 
                  />
                )}

                {/* TÍTULO INFERIOR (SUBIDO E MENOR) */}
              <div style={{ position: 'absolute', left: '20px', bottom: '60px', zIndex: '10', color: '#fff', maxWidth: '80%', textShadow: '1px 1px 3px rgba(0,0,0,0.9)', pointerEvents: 'none' }}>
                <h3 style={{ margin: '0 0 2px 0', fontSize: '10px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <span style={{ backgroundColor: '#E50914', padding: '1px 4px', borderRadius: '3px', fontSize: '8px' }}>SHORTS</span>
                  Doisplay
                </h3>
                <p style={{ margin: 0, fontSize: '11px', lineHeight: '1.1', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                  {video.title}
                </p>
              </div>

              </div>
            </div>
          );
        })}
      </div>

   {/* 🛡️ MENU DE TRÊS PONTINHOS DISCRETO E TELA CHEIA */}
      <div style={{
        position: 'absolute',
        bottom: '120px',
        right: '12px',
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '6px'
      }}>
        
        {/* 👇 NOVO: Botão de Tela Cheia */}
        <button
          onClick={toggleFullScreen}
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: 'rgba(0,0,0,0.4)',
            border: '1px solid rgba(255,255,255,0.2)',
            color: '#fff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(4px)',
            boxShadow: '0 4px 10px rgba(0,0,0,0.5)'
          }}
          title="Tela Cheia"
        >
          <Maximize size={16} />
        </button>

        {/* Botão de Três Pontinhos */}
        <button
          onClick={() => {
            const menu = document.getElementById('shorts-auto-menu');
            if (menu) {
              menu.style.display = menu.style.display === 'flex' ? 'none' : 'flex';
            }
          }}
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: 'rgba(0,0,0,0.4)',
            border: '1px solid rgba(255,255,255,0.2)',
            color: '#fff',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(4px)',
            boxShadow: '0 4px 10px rgba(0,0,0,0.5)'
          }}
          title="Opções"
        >
          ⋯
        </button>

        {/* Caixinha do Menu (Fica oculta por padrão e abre ao clicar) */}
        <div 
          id="shorts-auto-menu"
          style={{
            display: 'none',
            flexDirection: 'column',
            gap: '6px',
            backgroundColor: 'rgba(20, 20, 20, 0.85)',
            padding: '8px',
            borderRadius: '12px',
            border: '1px solid rgba(255,255,255,0.15)',
            backdropFilter: 'blur(8px)',
            boxShadow: '0 4px 15px rgba(0,0,0,0.6)'
          }}
        >
          {/* Botão Auto Dentro do Menu */}
          <button
            onClick={() => setIsAutoPlay(!isAutoPlay)}
            style={{
              backgroundColor: isAutoPlay ? 'rgba(229, 9, 20, 0.4)' : 'rgba(255,255,255,0.1)',
              border: isAutoPlay ? '1px solid rgba(229, 9, 20, 0.6)' : '1px solid rgba(255,255,255,0.2)',
              color: '#fff',
              padding: '6px 10px',
              borderRadius: '8px',
              fontSize: '10px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              whiteSpace: 'nowrap'
            }}
          >
            <div style={{
              width: '6px', height: '6px', borderRadius: '50%',
              backgroundColor: isAutoPlay ? '#ff4d4d' : 'rgba(255,255,255,0.5)'
            }} />
            AUTO: {isAutoPlay ? 'ON' : 'OFF'}
          </button>

          {/* Botão de Ajuda (?) Dentro do Menu */}
          <button
            onClick={() => alert("MODO AUTO: O feed avança sozinho a cada 60 segundos. Para assistir vídeos maiores até o final, desative o AUTO e role a tela com o dedo. \n\nAviso: Pode acontecer de algum vídeo ficar indisponível temporariamente, mas estamos sempre atualizando com novidades!")}
            style={{
              backgroundColor: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: '#fff',
              padding: '6px 10px',
              borderRadius: '8px',
              fontSize: '10px',
              fontWeight: 'bold',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px'
            }}
          >
            Ajuda (?)
          </button>
        </div>
      </div>

     {/* ↕️ PAINEL DE SETAS CIMA / BAIXO (APENAS PC) */}
      <div className="desktop-arrows-container" style={{ 
        position: 'absolute', 
        right: 'calc(50% - 220px)', 
        top: '50%',                    // 👈 SUBIR OU DESCER TUDO: 50% é o meio exato. Menos (ex: 40%) sobe, Mais (ex: 60%) desce.
        transform: 'translateY(-50%)', // 👈 Mantém as setas centralizadas perfeitamente no eixo Y
        display: 'flex', 
        flexDirection: 'column', 
        gap: '35px',                   // 👈 ESPAÇO ENTRE AS SETAS: aumente se quiser elas mais separadas
        zIndex: 50 
      }}>
        {activeIndex > 0 && (
          <button 
            onClick={() => scrollToVideo(activeIndex - 1)}
            style={{
              backgroundColor: 'rgba(255,255,255,0.15)', 
              border: '1px solid rgba(255,255,255,0.3)', 
              color: '#fff',
              borderRadius: '50%', 
              width: '30px',           // 👈 TAMANHO DO BOTÃO: mude para 35px (menor) ou 55px (maior)
              height: '30px',          // 👈 Acompanha a largura (width) para continuar sendo um círculo perfeito
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              cursor: 'pointer',
              transition: 'background 0.2s'
            }}
            title="Vídeo Anterior"
          >
            {/* size = Tamanho do desenho da seta | strokeWidth = Espessura (1 é mais fino, 3 é mais grosso) */}
            <ChevronUp size={26} strokeWidth={2} />
          </button>
        )}

        {activeIndex < shortsVideos.length - 1 && (
          <button 
            onClick={() => scrollToVideo(activeIndex + 1)}
            style={{
              backgroundColor: 'rgba(255,255,255,0.15)', 
              border: '1px solid rgba(255,255,255,0.3)', 
              color: '#fff',
              borderRadius: '50%', 
              width: '30px',           // 👈 TAMANHO DO BOTÃO: mude para 35px (menor) ou 55px (maior)
              height: '30px',          // 👈 Acompanha a largura (width)
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              cursor: 'pointer',
              transition: 'background 0.2s'
            }}
            title="Próximo Vídeo"
          >
            {/* size = Tamanho do desenho da seta | strokeWidth = Espessura (1 é mais fino, 3 é mais grosso) */}
            <ChevronDown size={26} strokeWidth={2} />
          </button>
        )}
      </div>

    </div>
  );
}